import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { GasGeneralHelper } from '@cikrf/gas-utils/helpers';

/**
 * @description Компонент для показа примера, с откытием кода, ts/html
 *
 * @example <sb-exampler title="Title" tsFile="asd.component.ts" htmlFile="asd.component.html"></sb-exampler>
 */
@Component({
  selector: 'sb-exampler',
  templateUrl: './sb-exampler.component.html',
  styleUrls: ['./sb-exampler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbExamplerComponent {
  @Input()
  public title = '';

  @Input()
  public tsFile: string;

  @Input()
  public htmlFile: string;

  @Input()
  public template: TemplateRef<void>;

  @Input()
  public language = 'typescript';

  public isExpandedTypescript = false;
  public isExpandedHtml = false;
  public isExpandedTemplate = false;
  public isCopied = false;

  private currentListing: string;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  public toggleTypescript(): void {
    this.isExpandedTypescript = !this.isExpandedTypescript;
    this.isExpandedHtml = false;

    this.changeDetectorRef.detectChanges();
  }

  public toggleHtml(): void {
    this.isExpandedHtml = !this.isExpandedHtml;
    this.isExpandedTypescript = false;

    this.changeDetectorRef.detectChanges();
  }

  public toggleTemplate(): void {
    this.isExpandedTemplate = !this.isExpandedTemplate;

    this.changeDetectorRef.detectChanges();
  }

  public copy(): void {
    this.isCopied = true;

    GasGeneralHelper.copyText(this.currentListing);

    setTimeout(() => {
      this.isCopied = false;

      this.changeDetectorRef.detectChanges();
    }, 3000);
  }

  public emitCode(listing: string): void {
    this.currentListing = listing;
  }
}
